import { stats, testimonials } from '@/mocks/content';

export default function StatsSection() {
  return (
    <>
      <section className="bg-secondary-900">
        <div className="w-full px-4 py-12 md:px-8 md:py-14">
          <div className="grid grid-cols-2 gap-6 lg:grid-cols-4">
            {stats.map((stat) => (
              <div key={stat.label} className="flex items-start gap-3">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center bg-secondary-800 text-accent-400">
                  <i className={`${stat.icon} text-lg`} aria-hidden="true" />
                </span>
                <span>
                  <span className="block font-heading text-xl font-bold text-background-50 md:text-2xl">
                    {stat.value}
                  </span>
                  <span className="mt-1 block text-xs text-secondary-300">{stat.label}</span>
                </span>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="border-b border-background-200 bg-background-50">
        <div className="w-full px-4 py-14 md:px-8 md:py-16">
          <div className="flex flex-wrap items-end justify-between gap-3">
            <div>
              <p className="text-xs uppercase tracking-[0.25em] text-primary-600">Reader Voices</p>
              <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
                读者怎么说
              </h2>
            </div>
          </div>

          <div className="mt-8 grid grid-cols-1 gap-5 md:grid-cols-3">
            {testimonials.map((item) => (
              <figure key={item.id} className="flex h-full flex-col border border-background-200 bg-background-100 p-6">
                <i className="ri-double-quotes-l text-2xl text-accent-500" aria-hidden="true" />
                <blockquote className="mt-4 flex-1 text-sm leading-relaxed text-foreground-700">
                  {item.text}
                </blockquote>
                <figcaption className="mt-5 flex items-center gap-3 border-t border-background-200 pt-4">
                  <span className="flex h-9 w-9 items-center justify-center bg-primary-100 font-heading text-sm font-bold text-primary-700">
                    {item.initial}
                  </span>
                  <span>
                    <span className="block text-sm font-medium text-foreground-950">{item.name}</span>
                    <span className="block text-xs text-foreground-500">{item.role}</span>
                  </span>
                </figcaption>
              </figure>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}